import React from "react";
import { Redirect } from "react-router-dom";
import { getManagedCompanyIdx, isAgentSession } from "../../util/workingCompany";

/**
 * 특사(대리인)인데 선택 기업(manage_company_idx)이 없으면 /choice 로 이동.
 * 특허·상표·디자인·비용관리·직무발명신고 라우트에 적용.
 */
export default function withAgentManagedCompany(WrappedComponent) {
  function AgentManagedCompanyGate(props) {
    if (isAgentSession() && !getManagedCompanyIdx()) {
      return <Redirect to="/choice" />;
    }
    return <WrappedComponent {...props} />;
  }

  const wrappedName =
    WrappedComponent.displayName || WrappedComponent.name || "Component";
  AgentManagedCompanyGate.displayName = `withAgentManagedCompany(${wrappedName})`;
  return AgentManagedCompanyGate;
}
